// Navidium-Texte im Warenkorb aus den Theme-Einstellungen (TROOP-864).
//
// Die Navidium-Einbettung schreibt ihre Konfiguration als `const nvdConsentConfig = {…}` in die
// Seite; das Widget (nvd-widget-with-consent.js, defer) liest daraus bei jedem Aufbau Überschrift,
// Untertitel und die Knopftexte. Dieses Script läuft vorher (defer, im <head>) und setzt dort die
// Texte in der Sprache der Seite. Leere Einstellungen lassen Navidiums Text stehen. Fehlt die
// Konfiguration (Navidium aus oder umgebaut), passiert nichts.
// Abhängigkeit von Navidiums internen Namen: siehe HORIZON-ANPASSUNGEN.md.

(() => {
  const source = document.getElementById('ap-nvd-texts');
  // Globale `const` aus einem anderen Script: nur über typeof prüfbar, ohne ReferenceError.
  if (!source || typeof nvdConsentConfig === 'undefined') return;

  let texts;
  try {
    texts = JSON.parse(source.textContent);
  } catch {
    return;
  }

  const widget = nvdConsentConfig?.standard_widget;
  const heading = widget?.heading?.section_content;
  const buttons = widget?.cta_button?.section_content;

  if (heading) {
    if (texts.title) heading.title = texts.title;
    if (texts.subtitle) heading.subtitle = texts.subtitle;
  }
  if (buttons) {
    if (texts.button) buttons.button_text = texts.button;
    if (texts.buttonWithout) buttons.secondary_button_text = texts.buttonWithout;
  }
})();
